import "./BillEntry.scss";

export interface BillEntryProps {
    title: string;
    totalCost: string;
    costInfo: string;
    disclaimer?: string;
    style?: any;
    additionalDisclaimer?: string;
}

const BillEntry = (props: BillEntryProps) => {
    function getDisclaimer(): any {
        if (props.disclaimer && props.disclaimer !== 'null' && props.disclaimer !== 'undefined')
            return <div className="Disclaimer">{props.disclaimer}</div>
    }

    function getAdditionalDisclaimer(): any {
        if(props.additionalDisclaimer && props.additionalDisclaimer !== 'null' && props.additionalDisclaimer !== 'undefined') {
            return <div className="Disclaimer">{props.additionalDisclaimer}</div>
        }
    }

    return (
        <div className="BillEntry" style={props.style}>
            <div className={"Billing"}>
                <div style={{maxWidth: 220}}>{props.title}</div>
                <div>{props.totalCost}</div>
            </div>
            <span>{props.costInfo}</span>
            {getDisclaimer()}
            {getAdditionalDisclaimer()}
        </div>
    )
}

export default BillEntry;
